export default __webpack_public_path__ + "static/media/예스휴먼.26ca7d2d.jpg";